
angular
.module('index')

	// Map view controller
	.controller('EventChangeGroupController', function($scope, $translate, Classes, ApiRootUrl, $state, $stateParams, FormService, MetaService, $q) {

        this.ApiRootUrl = ApiRootUrl;
		var self = this;
		self.hash = $stateParams.hash;
		self.is_busy = false;
		self.participation = null;
		self.errorMessage = null;
		
		MetaService.setTitle()
		MetaService.setMetaKeywords()
		MetaService.setMetaDescription()
		
		this.readEventParticipation = function(){
			Classes.EventParticipation.event_groups_info({
				hash: self.hash
			})
			.then(function(resp){
				self.is_busy = false;
				self.participation = resp.participation;
				self.event_group = resp.event_group;
				self.event = resp.event;
				
				if(self.event_group)
					self.formValues.event_group = self.event_group.id;
				
				self.addGroupSelectionFields();				
			}).catch(function(e){
				self.is_busy = false;
				self.errorMessage = {type:'danger', body: e.data.message};
			});
		}
		self.readEventParticipation();
		
		// Build survey form
		self.formRegisterGroup = null;
		self.formRegisterGroupCustom = null;
		self.formFields = [];
		self.formMessage = null;
		self.formValues = {};	// From values
		self.formLayout = ['survey-form'];
		
		self.form = FormService.createForm({
			layout: self.formLayout,
			params: self.formFields,
			submit: function(data) {
				
				// Participation event_group
				self.formRegisterGroup = data.event_group;
				self.formRegisterGroupCustom = data.event_group_custom;
				
				// Save survey
				return Classes.EventParticipation.registration_change_group({
					event_group: self.formRegisterGroup,
					event_group_custom: self.formRegisterGroupCustom,
					hash: self.hash
				}).then(function(resp){
					$state.go('regstration-info', {hash: self.hash});
				}).catch(function(e){
					self.errorMessage = {type:'danger', body: e.data.message};
					return $q.reject(e)  // FormService ustawi field_errors itp.
				});
				
			},
		}, self.formValues);
		
		this.addGroupSelectionFields = function(){
			self.formFields.length = 0;
			angular.forEach(self.event.event_groups, function(group, key) {
				
				var field = {
					//default:undefined,
					editable:"true",
					groups:['survey-form'],
					name: 'event_group',
					required: true,
					title: group.title,
					type: 'EventGroup',
					visible:"true",
					client: {
						'id': group.id,
						box_template_url: 'partials/index/field-box.html',
						group_date: group.event_full_date,
						group_name: group.title
					}
				}
				if(self.isEventGroupAvaliable(group))
					self.formFields.push(field);
			});
		}
		
		this.isEventGroupAvaliable = function(group){
			
			var now = new Date();
			var start = new Date(group.registration_start);
			var end = new Date(group.registration_end);
			
			if(now < start || now > end )
				return false;
			
			if (group.is_blocked || group.is_hidden)
				return false;
			
			return true;
		}
		
		this.goBack = function(){
			$state.go('regstration-info', {hash: self.hash});
		}
		
        window.Classes = Classes;
        window.$ctrl = this;

    })
	;
